export const sitesApi = (client) => ({
    /// Pass `allCustomers: true` for cross-customer pickers (invite dialog,
    /// role grants) so the active-customer switcher doesn't hide rows
    /// under sibling customers.
    list: (opts) => client.get('/api/v1/sites', {
        params: opts?.allCustomers ? { all_customers: '1' } : undefined,
    }).then((r) => r.data),
    get: (id) => client.get(`/api/v1/sites/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/sites', body).then((r) => r.data),
    /// Bulk-import sites from a CSV. The backend wraps the inserts in a
    /// single transaction — either every row lands or none does, so a
    /// retry after fixing the spreadsheet is safe.
    bulkCreate: (sites) => client.post('/api/v1/sites/bulk', { sites }).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/sites/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/sites/${id}`).then((r) => r.data),
});
//# sourceMappingURL=sites.js.map